import { AmplifyConfig, InterfaceConfig } from "@interfaces/response";
import { createTheme, ThemeOptions } from "@mui/material";
import { themeBase } from "./_themeBase";

const theme: ThemeOptions = {
  palette: {
    primary: {
      main: "#D45D00",
      dark: "#333F48",
      light: "#FFC72C",
      base: "#FFF8E6",
      accent: "#D97B4B",
    },
    components: {
      slider: {
        rail: "#FFF8E6",
        track: "#333F48",
        thumbIcon: "#D97B4B",
        label: "#333F48",
      },
      progressBar: {
        rail: "#D9D9D9",
        track: "#D45D00",
      },
      buttonSelect: {
        backgroundColor: "#D45D00",
        textColor: "#333F48",
        backgroundColorActive: "#333F48",
        textColorActive: "#FFFFFF",
        bordeColorActive: "#FFC72C",
      },
    },
  },
};

export const CustomTheme = createTheme(themeBase, theme);

export const interfaceConfig: InterfaceConfig = {
  name: "finbe",
  home_url: import.meta.env.VITE_URL_HOME_FINBE,
  aviso_privacidad: import.meta.env.VITE_URL_HOME_FINBE + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_FINBE + "/terminos-y-condiciones",
  terminos_condiciones_empresa: import.meta.env.VITE_URL_HOME_FINBE + "/terminos-y-condiciones-credito-empresarial",
  interest_rate: 30,
  metadata: {
    title: "Soluciones financieras para crecer tu negocio",
    description: "Solicita en minutos un crédito simple y sin garantía",
    favicon: "finbe/portal/logos/favicon.ico",
    ogImage: "https://develop.d1yqxqednb1e91.amplifyapp.com/opengraph-image.jpg?c044d823f8594106",
  },
  navbar: {
    logo: "finbe/portal/logos/logo_dark.png",
    logo_width: 142,
    logo_height: 32,
  },
  lateral: {
    logo_light: "finbe/portal/logos/logo_light_bg.png",
    bg_light: "#FFC72C",
    text_light: "#333F48",
    logo_dark: "finbe/portal/logos/logo_dark_bg.png",
    bg_dark: "#333F48",
    text_dark: "#FFFFFF",
    image_list: [
      "finbe/portal/lateral/imagen_1.webp",
      "finbe/portal/lateral/imagen_2.webp",
      "finbe/portal/lateral/imagen_3.webp",
      "finbe/portal/lateral/imagen_4.webp",
      "finbe/portal/lateral/imagen_5.webp",
      "finbe/portal/lateral/imagen_6.webp",
      "finbe/portal/lateral/imagen_7.webp",
      "finbe/portal/lateral/imagen_8.webp",
      "finbe/portal/lateral/imagen_9.webp",
      "finbe/portal/lateral/imagen_10.webp",
    ],
    text_list: [
      "Tu empresa merece soluciones a su medida",
      "Impulsa tu negocio con el respaldo que necesitas",
      "Haz realidad tus planes de crecimiento",
      "El futuro de tu empresa comienza hoy",
      "Aquí, el siguiente paso lo das tú",
      "Solidez y confianza para avanzar juntos",
      "Más oportunidades para el desarrollo de tu empresa",
      "Decide, avanza y haz crecer tu negocio",
      "Soluciones simples para empresas que quieren más",
      "Construye tu historia de éxito con FinBe",
    ],
  },
  textos_tofu: {
    pm: {
      crear_cuenta: {
        titulo: "Te damos la bienvenida",
        sub_titulo: "",
      },
      registro_datos_personales: {
        titulo: "Creación de cuenta",
        sub_titulo: "",
      },
      validacion_telefono: {
        titulo: "Validación de teléfono",
        sub_titulo: "",
      },
      datos_empresa_pm: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      consulta_ciec: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      uso_de_credito: {
        titulo: "Selección de uso de crédito",
        sub_titulo: "",
      },
      presencia_digital_pm: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
      datos_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      rfc_curp: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      domicilio_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      consulta_buro_nip: {
        titulo: "Validación para consulta buró",
        sub_titulo: "",
      },
      buro_bloqueado: {
        titulo: "Consulta de Buró de Crédito del Accionista Bloqueada",
        sub_titulo: "",
      },
    },

    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
      consulta_buro_pfae: {
        titulo: "Consulta Buró",
        sub_titulo: "",
      },
      domicilio_pfae: {
        titulo: "Domicilio",
        sub_titulo: "",
      },
      presencia_digital_pfae: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
    },
  },
  maps: {
    api_key:
      import.meta.env.VITE_ENV === "PROD"
        ? "AIzaSyAiV-uuz8-emZFpk28KuxPiy95Y_yKZIp0"
        : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: [
    "Financiera Bepensa SA DE CV SOFOM ER",
    "Bepensa Leasing SA DE CV",
    "AB&C Leasing de México SAPI DE CV",
    "Lendit Group SAPI de CV",
  ],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
  firma: {
    video_url:
      import.meta.env.VITE_ENV === "PROD"
        ? "https://static-resource.lendia.mx/finbe/portal/media/customer_welcome-signature.mp4"
        : "https://static-resource.lenditgroup.com/finbe/portal/media/customer_welcome-signature.mp4",
    provider: "legalario",
    legalario_config: {
      custom_url_sdk: import.meta.env.VITE_ENV === "PROD" ? "https://sdk.legalario.com/finBe/sdk-dist.js" : "",
      organization_id: import.meta.env.VITE_ENV === "PROD" ? "6834e22990aa7213b84e5522" : "680fb72a3750460f1c548673",
      api_key:
        import.meta.env.VITE_ENV === "PROD"
          ? "7f9c2ba4e88f827d616045507605853ed73b8093a03f8aa2b7e0e2c78c1e6025"
          : "f65d302d4fbdd71f13fd629e0b67a8971afa1f72cc931bc55f6c6e1f2094fdab",
    },
    condiciones_credito: {
      monto: true,
      plazo: true,
      tasa: false,
    },
    habilitar_calendario_pagos: true,
    habilitar_tabla_amortizacion: true,
  },
  scripts: {
    tag_id_google: "G-GRSNLB3TYW",
    tag_id_linkedin: "6355068",
    tag_id_hotjar: "6412809",
    tag_id_meta_pixel: "1135735424251241",
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_YWntpKnYk",
      userPoolClientId: "4qiq9837g21na4jrpnm6s6rokd",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_6Kcxh4l1m",
      userPoolClientId: "5fveuoevde7c8f7scm3dbm5j63",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
